import React from "react";
import { useSelector } from "react-redux";
import { acceptanceScreenSelector } from "datamodel/Features/selectors";
import OldEnquiry from "./enquiry";
import NewEnquiry from "./enquiry-v2";

const EnquiryAB = (props) => {
  const newAcceptanceScreen = useSelector(acceptanceScreenSelector);
  const Enquiry = newAcceptanceScreen ? NewEnquiry : OldEnquiry;

  return <Enquiry {...props} />;
};

export default EnquiryAB;
